var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{attrs:{"color":"warning"}},[_c('div',{staticStyle:{"color":"white","font-weight":"bold"}},[_vm._v(" လစဉ်အထူးကြော်ငြာပြုလုပ်နိုင်သည့် အရေအတွက် ကုန်သွားပါပြီ ")])]),_c('v-btn',{attrs:{"block":"","color":"warning","to":{
      name: 'PackagePlan',
    }}},[_vm._v(" Package Plan များ ကြည့်ရန် ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }